import { FormDefinitionType } from "../features/task";
import { AccountType } from "../model/AccountType";
import FieldDefinition from "../model/FieldDefinition";
import API, { responseOf } from "./base";

export const get = (id: string): Promise<FieldDefinition> =>
  responseOf(API.get(`/field-definitions/${id}`, { public: true }));

export const getWithoutParentElements = (
  id: string,
): Promise<FieldDefinition> =>
  responseOf(
    API.get(`/field-definitions/${id}`, {
      public: true,
      params: {
        includeParentElements: false,
      },
    }),
  );

export const create = (
  fieldDefinition: FieldDefinition,
): Promise<FieldDefinition> =>
  responseOf(API.post(`/field-definitions`, fieldDefinition));

export const update = (
  fieldDefinition: FieldDefinition,
): Promise<FieldDefinition> =>
  responseOf(
    API.put(`/field-definitions/${fieldDefinition.id}`, fieldDefinition),
  );

export const getSubjects = (
  fieldDefinitionId: string,
): Promise<AccountType[]> =>
  responseOf(API.get(`/field-definitions/${fieldDefinitionId}/subjects`));

export const updateElements = async (
  fieldDefinitionId: string,
  elements: FormDefinitionType[],
): Promise<FieldDefinition> => {
  const fieldDefinition = await get(fieldDefinitionId);
  return update({ ...fieldDefinition, data: { elements } });
};

const deleteFieldDefinition = async (
  fieldDefinitionId: string,
): Promise<void> => {
  await API.delete(`/field-definitions/${fieldDefinitionId}`);
};
export { deleteFieldDefinition as delete };
